module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Layers-24464a6f278f147426600841dcd43d7e.svg";